<template>
    <div>
        <v-list-item @click.stop="dialog = true">
            <v-list-item-title>Add Drivers Half Board</v-list-item-title>
        </v-list-item>
        <v-dialog width="700px" v-model="dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Drivers Half Board Register</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form"

                        >
                            <v-row>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="First Name*"
                                            hint="enter first name"
                                            required
                                            v-model="firstName"
                                            :error-messages="firstNameErrors"
                                            @input="$v.firstName.$touch()"
                                            @blur="$v.firstName.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Last Name*"
                                            hint="enter a last name"
                                            v-model="lastName"
                                            :error-messages="lastNameErrors"
                                            required
                                            @input="$v.lastName.$touch()"
                                            @blur="$v.lastName.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Driver Email*"
                                            required
                                            v-model="email"
                                            :error-messages="emailErrors"
                                            @input="$v.email.$touch()"
                                            @blur="$v.email.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <!--                            <v-col cols="6" sm="6">-->
                                <!--                                <v-file-input-->
                                <!--                                        clear-icon="mdi-close"-->
                                <!--                                        clearable-->
                                <!--                                        outlined-->
                                <!--                                        label="Upload Your Photo"-->
                                <!--                                        v-model="img"-->
                                <!--                                        persistent-hint-->
                                <!--                                ></v-file-input>-->
                                <!--                            </v-col>-->
                                <v-col cols="12" sm="12" class="area-select">
                                    <v-select
                                            outlined
                                            label="Areas Assigned to*"
                                            multiple
                                            chips
                                            deletable-chips
                                            hint="leave blank not to assign driver to any areas"
                                            persistent-hint
                                            v-model="area_ids"
                                            :items="areasList"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="selectAreaErrors"
                                            @change="onChangeArea"
                                            @blur="$v.area_ids.$touch()"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" class="drivers_resturants-select">
                                    <v-select
                                            outlined
                                            label="Area's Restaurants Assigned to"
                                            multiple
                                            chips
                                            deletable-chips
                                            hint="if leave blank driver to be assigned to all Area's estaurants"
                                            persistent-hint
                                            v-model="restaurant_ids"
                                            :items="restaurantsList"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="area_ids.length == 0"
                                            :error-messages="selectRestaurantErrors"
                                            @change="onChangeRestaurant"
                                            @blur="$v.restaurant_ids.$touch()"
                                    ></v-select>
                                </v-col>

                            </v-row>

                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="submit"
                                >Add
                                </v-btn>
                                <v-btn
                                        class="warning"
                                        :loading="localLoading"
                                        depressed
                                        @click="clear"
                                >
                                    <v-icon left>mdi-cancel</v-icon>
                                    Clear
                                </v-btn>
                            </div>

                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {validationMixin} from 'vuelidate'
    import {required, /* maxLength,*/ email, /*numeric*/} from 'vuelidate/lib/validators'
    import axios from 'axios'
    import * as _ from 'lodash';

    export default {
        mixins: [validationMixin],
        name: "NewLocationModal",
        props: ['thisAreaData'],
        validations: {
            firstName: {required, /* maxLength: maxLength(10)*/},
            email: {required, email},
            lastName: {required},
            area_ids: {},
            restaurant_ids: {}
        },
        data: () => ({
            /*valid: false,*/
            readOnly: false,
            localLoading: false,
            dialog: false,
            firstName: '',
            email: '',
            lastName: '',
            area_ids: [],
            restaurant_ids: [],
            response_errors: [],
        }),
        created(){

        },
        updated(){
            if (this.thisAreaData) {
                this.area_ids = [+this.thisAreaData.id];
                this.readOnly = true;
            }
        },
        computed: {
            ...mapGetters([
                'areas',
                'restaurants',
            ]),
            selectAreaErrors () {
                const errors = [];
                if (!this.$v.area_ids.$dirty) {
                    return errors;
                }
                // !this.$v.area_ids.required && errors.push('Area is required');
                return errors
            },
            selectRestaurantErrors () {
                const errors = [];
                if (!this.$v.restaurant_ids.$dirty) {
                    return errors;
                }
                // !this.$v.restaurant_ids.required && errors.push('Resturants is required');
                return errors
            },
            firstNameErrors () {
                const errors = []
                if (!this.$v.firstName.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.firstName.required && errors.push('First name is required.')
                return errors
            },
            lastNameErrors () {
                const errors = []
                if (!this.$v.lastName.$dirty) return errors
                !this.$v.lastName.required && errors.push('Last Name is required.')
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push('Must be valid e-mail')
                !this.$v.email.required && errors.push('E-mail is required')

                // response errors
                let resp_errors = _.get(this.response_errors, 'email', []);
                _.each(resp_errors, p => errors.push(p));

                return errors
            },
            areasList() {
                return this.areas;
            },
            restaurantsList() {
                if (this.area_ids.length == 0) {
                    return [];
                }

                return _.filter(this.restaurants, p => this.area_ids.indexOf(+p.area_id) !== -1);
            },
        },

        methods: {
            onChangeArea (/*values*/) {
                let areas_restaurants = _.map(this.restaurantsList, p => p.id);

                // clear selected restaurants on change area
                this.restaurant_ids = _.intersection(areas_restaurants, this.restaurant_ids);
            },
            onChangeRestaurant(/*values*/) {
                // debugger;
            },
            submit () {
                this.localLoading = true,
                    this.$v.$touch()
                if (!this.$v.$invalid) {
                    const newDriver = {
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        area_ids: this.area_ids,
                        restaurant_ids: this.restaurant_ids,
                    };

                    this.$store.dispatch('createNewDriver', {payload: newDriver, params: {'halfBoard': true}}).then((data) => {
                        this.dialog = false;
                        this.clear();
                    })
                    .catch((errors) => {
                        this.response_errors = errors;
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                }
            },
            clear () {
                this.$v.$reset();
                this.firstName = '';
                this.email = '';
                this.lastName = '';
                this.restaurant_ids = [];
                this.area_ids = [];
            },
        },
    }
</script>

<style scoped>

</style>